import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '../inputs/Button';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { setIsLanguagePopupOpened } from '../../../redux/features/general/navigation';
import LanguageRow from '../../consultation/updated/popups/items/LanguageRow';
import { updateDoctorPreferences } from '../../../routes/doctor/patients';
import CancelButton from '../inputs/CancelButton';

const LanguagePopup: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { consultationId } = useParams();
    const colors = useAppSelector(state => state.theme.colors);

    // This popup uses the global i18n language state
    const currentAppLanguage = i18n.language;

    const handleLanguage = async (newLanguage: string) => {
        i18n.changeLanguage(newLanguage);
        const content = { language: newLanguage };
        await updateDoctorPreferences(content);
        dispatch(setNotificationMessage(t('languageUpdated')));
        dispatch(setIsLanguagePopupOpened(false));
    };

    const handleQuit = () => {
        dispatch(setIsLanguagePopupOpened(false));
    };

    return (
        <Box onClick={handleQuit} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', backgroundColor: colors?.popup, overflow: 'hidden', position: 'absolute', zIndex: 100000000 }}>
            <Box onClick={(e) => e.stopPropagation()} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', textAlign: 'center', maxWidth: isMobile ? '90vw' : '400px', width: '100%', padding: isMobile ? 2 : 3, borderRadius: isMobile ? 3 : 5, fontSize: 14, backgroundColor: colors?.container }}>
                <Box sx={{ width: '80%', fontSize: 16, marginBottom: isMobile ? 2 : 3, whiteSpace: 'pre-line' }}>
                    {`Choisissez une langue\nChoose a language`}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'none' }}>
                    <LanguageRow
                        icon={<PublicOutlinedIcon />}
                        title={'fr'}
                        handler={() => handleLanguage('fr')}
                        isActive={currentAppLanguage === 'fr'} // Pass the correct boolean
                    />
                    <LanguageRow
                        icon={<PublicOutlinedIcon />}
                        title={'en'}
                        handler={() => handleLanguage('en-US')}
                        isActive={currentAppLanguage === 'en-US' || currentAppLanguage === 'en'} // Pass the correct boolean
                    />
                    <Button
                        title='continue'
                        triggerFunction={handleQuit}
                        extraStyle={{ marginTop: isMobile ? 2 : 4, marginBottom: 2, width: '60%' }}
                    />
                </Box>
            </Box>
            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />
        </Box>
    );
};

export default LanguagePopup;